// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"55":"fe6d6e9f","496":"3fd02b7a"}[chunkId] + ".chunk.js";
};